export default {"src":"/_next/static/media/SG.4efe43e4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};